<template>
  <div id="table-exhibited-work" class="result-table">
    <el-table
      stripe
      border
      :data="results"
      @sort-change="setOrderColumn">
      <el-table-column type="expand">
        <template slot-scope="props">
          <p>
            <strong v-if="props.row.section_title">{{$t('pages.results.section')}} : {{props.row.section_title}}</strong>
            <span
              v-if="props.row.id_exhibition_section"
              @click="openSectionDialog(props.row.id_exhibition_section)"
              class="section-link"
            >
              {{$t('pages.results.section_link')}}
            </span>
            <br>
            <span v-if="props.row.space || props.row.section_address">
              {{$t('pages.results.exhibitedSpace')}} : {{props.row.space}}
              <span v-if="props.row.space || props.row.section_address">, </span>
              <span v-if="props.row.section_address" class="section_address">{{props.row.section_address}}</span>
            <br></span>
            <span v-if="props.row.number || props.row.category">
              <span v-if="props.row.number">
                {{$t('pages.results.exhibitedWork')}} n°{{props.row.number}}
              </span>
              <span v-if="props.row.number && props.row.category"> - </span>
              <span v-if="props.row.category">
                {{$t('pages.results.category')}} : {{ props.row.category }}
              <br></span>
            <br></span>
            <span v-if="props.row.year_c1">
              {{$t('pages.results.creationDate')}} :
              <span v-if="props.row.month_c1 !== 0"><span v-if="props.row.day_c1 !== 0">{{ props.row.day_c1 }}/</span>{{ props.row.month_c1 }}/</span>{{ props.row.year_c1 }}
            <br></span>
            <span v-if="props.row.year_c2">
              {{$t('pages.results.creationDate2')}} :
              <span v-if="props.row.month_c2 !== 0"><span v-if="props.row.day_c2 !== 0">{{ props.row.day_c2 }}/</span>{{ props.row.month_c2 }}/</span>{{ props.row.year_c2 }}
            <br></span>
            <span v-if="props.row.city_c">
              {{$t('pages.results.creationSpace')}} : {{ props.row.id_address_c }} {{ props.row.country_c }} {{ props.row.city_c }} {{ props.row.state_c }}
            <br></span>
            <span v-if="props.row.size">
              {{$t('pages.results.size')}} : {{props.row.size}}
            <br></span>
            <span v-if="props.row.medium">
              {{$t('pages.results.medium')}} : {{ props.row.medium }}
            <br></span>
            <span v-if="props.row.room">
              {{$t('pages.results.room')}} : {{ props.row.room }}
            <br></span>
            <span v-if="props.row.is_reproduced_in_catalog">
              {{$t('pages.results.exhibitedWorkReproduceInCatalog')}} :
              <span v-if="props.row.is_reproduced_in_catalog !== 't'">({{ props.row.is_reproduced_in_catalog }})</span>
            <br></span>
            <span v-if="props.row.price">
              {{$t('pages.results.price')}} : {{props.row.price}}
            <br></span>
            <span v-if="props.row.owner">
              {{$t('pages.results.owner')}} : {{ props.row.owner }}
            <br></span>
            <span v-if="props.row.source">
              {{$t('pages.results.sources')}} : <cite>{{ props.row.source }}</cite>
            <br></span>
            <span v-if="props.row.notes">
              {{$t('pages.results.notes')}} : {{props.row.notes}}
            <br></span>
          </p>
          <cite>
            {{$t('pages.results.credits')}}
            {{$t('pages.results.filledBy')}}
            <span v-if="props.row.contributor">{{ props.row.contributor }}.</span>
            <span v-else>{{$t('pages.results.contributorUnknown')}}</span>
          </cite>
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        sortable
        min-width="180"
        :label="$t('pages.results.exhibitedWorkTitle')">
        <template slot-scope="scope">
          <p class="results-title">{{scope.row.title}}</p>
          <p v-if="scope.row.subtitle" class="results-subtitle">{{scope.row.subtitle}}</p>
          <p v-if="scope.row.translation_title" class="results-translate-title">{{scope.row.translation_title}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="exhibitor_name"
        sortable
        :label="$t('pages.results.name')" />
      <el-table-column
        prop="exhibitor_first_name"
        sortable
        min-width="120"
        :label="$t('pages.results.firstname')"/>
      <el-table-column
        label="Exposition"
        header-align="center"
        >
        <el-table-column
          prop="begin_date"
          sortable
          :formatter="formatDate"
          :label="$t('pages.results.year')"/>
        <el-table-column
          prop="exhibition_city"
          sortable
          :label="$t('pages.results.city')"/>
        <el-table-column
          prop="exhibition_title"
          sortable
          min-width="180"
          :label="$t('pages.results.title')"/>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Table, TableColumn, Button
} from 'element-ui'

import { OPEN_SECTION_ID_DIALOG } from '../../../store/dialog/actions'
import { upperCase, formatDate } from '../../../services/formatter'

export default {
  name: 'table-exhibited-work',
  props: ['results', 'setOrderColumn'],
  methods: {
    upperCase,
    formatDate,
    openSectionDialog (id) {
      this.$store.dispatch('dialog/' + OPEN_SECTION_ID_DIALOG, { id })
    }
  },
  components: {
    elTable: Table,
    elTableColumn: TableColumn,
    elButton: Button
  }
}
</script>

<style>
.results-translate-title {
  font-style: italic;
  color: #97a8be;
}
.results-title, .results-translate-title {
  margin: 0;
}

.section-link {
  color: #23a6b9;
}
.section-link:hover,
.section-link:active {
  text-decoration: underline;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Result/Tables/TableExhibitedWork.vue